import React from 'react'
import { MARK_STATUS, MARK_TEXT, QUERY_TYPE } from 'meinian-package/src/component/enum'
import { PLATFORM_CONFIG_ENUM, PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import { SampleState } from 'component/filter/sampleFilterOptions'
import Select, { MultiSelect } from 'meinian-package/src/baseComponent/selectBorder'
import css from './modal.module.less'

const BLOG_SEARCH_SCOPE_OPTIONS = [
  { label: '款式标题', value: 'title' },
  { label: '款式描述', value: 'description' },
  // { label: '款式的智能标签', value: 'intel_tag' },
  { label: '款式颜色', value: 'color' },
  { label: '款式属性', value: 'properties' },
  { label: '发布者名称', value: 'shop_name' }
]
const SAMPLE_SEARCH_SCOPE_OPTIONS = [
  { label: '样衣标题', value: 'title' },
  { label: '样衣描述', value: 'description' },
  { label: '样衣颜色', value: 'color' },
  { label: '样衣属性', value: 'properties' },
]
export function SelectBlogSearchScope({ onChange, value }) {
  return (
    <MultiSelect
      menuMaxHeight={400}
      allowClear
      option={BLOG_SEARCH_SCOPE_OPTIONS}
      placeholder="不限"
      multiple
      onChange={onChange}
      value={value}
    />
  )
}
export function SelectSampleSearchScope({ onChange, value }) {
  return (
    <MultiSelect
      menuMaxHeight={400}
      allowClear
      option={SAMPLE_SEARCH_SCOPE_OPTIONS}
      placeholder="不限"
      multiple
      onChange={onChange}
      value={value}
    />
  )
}

const QUERY_TYPE_OPTIONS = [
  { label: '不限', value: QUERY_TYPE.ALL },
  { label: '我拥有的', value: QUERY_TYPE.OWNER },
  { label: '我协作的', value: QUERY_TYPE.COOPERATION },
]
export function SelectQueryType({ value, onChange }) {
  return (
    <Select
      menuMaxHeight={400}
      placeholder="不限"
      key="inspiration2"
      value={value}
      onChange={onChange}
      option={QUERY_TYPE_OPTIONS}
    />
  )
}
export function SelectInspirationType({ value, onChange }) {
  return (
    <Select
      menuMaxHeight={400}
      allowClear
      placeholder="不限"
      key="inspiration1"
      option={[
        { label: '灵感集', value: 0 },
        { label: '灵感集PRO', value: 1 },
      ]}
      value={value}
      onChange={onChange}
    />
  )
}
export function SelectPlatform({ value, onChange }) {
  return (
    <MultiSelect
      menuMaxHeight={400}
      placeholder="不限"
      value={value}
      multiple
      allowClear
      onChange={onChange}
      option={[...PLATFORM_CONFIG_ENUM.values()]}
    />
  )
}
const MARK_STATUS_OPTIONS = [
  { label: MARK_TEXT[MARK_STATUS.PASS], value: MARK_STATUS.PASS },
  { label: MARK_TEXT[MARK_STATUS.PENDING], value: MARK_STATUS.PENDING },
  { label: MARK_TEXT[MARK_STATUS.NOT_PASS], value: MARK_STATUS.NOT_PASS },
  { label: MARK_TEXT[MARK_STATUS.UNSET], value: MARK_STATUS.UNSET },
]
export function SelectMarkStatus({ value, onChange }) {
  return (
    <Select menuMaxHeight={400} placeholder="不限" allowClear value={value} onChange={onChange} option={MARK_STATUS_OPTIONS} />
  )
}
export function SelectSampleState({ value, onChange }) {
  return (
    <span className={css.sampleSelect}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/*  @ts-ignore */}
      <SampleState placeholder="不限" value={value} onChange={onChange} />
    </span>
  )
}
